import {
    dictionary,
    locale,
    _
} from 'svelte-i18n';
function setupI18n({ withLocale: _locale} = { withLocale: 'en-US' }) {
    dictionary.set({
        'en-US': {
            'main': {
                pageTitle: null,
                pageTitleTag: 'DataJam',
                pageMetaDescription: 'DataJam',
                pageLinkCanonical: 'https://datajam.pro/dashboard',
                'termsLink': '/terms',
                'privacyLink': '/',
            },
            'header': {
                'menuLabel': 'Menu',
                'homeLabel': 'Dashboard',
                'addAccountLabel': 'Add an account',
                'tutorialsLabel': 'Guide',
                'subscriptionLabel': 'Prices and Subscription',
                'supportLabel': 'Technical support',
                'notificationsLabel': 'Notifications',
                'settingsLabel': 'Settings',
                'affilateProgramLabel': 'Affiliate program',
                'logOutLabel': 'Exit',
                'accountLabel': 'Account',
                'logo': '/spy20-lk/img/datajam-logo.svg',
                'logoSmall': '/spy20-lk/img/datajam-logo-small.svg',
                'affiliateProgramUrl': 'https://fruit-cpa.com/',
            },
            'addAccount': {
                'pageTitle': 'New target',
                'pageTitleTag': 'DataJam',
                'blockTitle': 'Activity analysis',
                'blockDescription': 'To start the analysis, add the account you are interested in. Paste the link or enter the account name:',
                'addButtonLabel': 'Add the target',
                'searchingLabel': 'Searching...',
                'error': 'Error',
                'inputPlaceholder': '@username or link',

                'titleAndDescription': 'title and description',
                'likes': 'likes',
                'comments': 'comments',
                'posts': 'posts',
                'postsMarks': 'marks on photos',
                'followsAndFollowers': 'follows and followers',
            },
            'analyzeControl': {
                'addButtonLabel': 'Add the target',
                'blockTitle': 'Activity analysis',
                'blockInitialDescription': 'Start gathering the first set of data right away!',
                'startAnalyzeBtnLabel': 'Run the analysis',
                'categoriesListTitle': 'Categories',
                'likesCategoryTitle': 'Likes',
                'followsCategoryTitle': 'Following',
                'followersCategoryTitle': 'Followers',
                'likersCategoryTitle': 'Admirers',
                'storiesCategoryTitle': 'Stories',
                'commentsCategoryTitle': 'Comments',
                'postsAndReelsCategoryTitle': 'Posts & Reels',
                'startAnalyzeBtnDescription': 'Click the "Run the analysis" button to get data on the activity of your target.',
                'lastUpdateDate': 'Last updated',
                'timeTillNextUpdate': 'Next update will be available in',
                'reanalyzeBtnLabel': 'Update data',
                'analyzeInProgressDescription': 'The account analysis remains ongoing and will take a while to complete.<br />Come back a bit later.',
                'analyzeInProgressStatus': 'Analysis in progress',
                'previousCategoryLabel': 'Previous category',
                'nextCategoryLabel': 'Next category',
            },
            'analyzeLimitAlert': {
                'disclaimer': 'Under the current plan, you can analyze only {limit} {target_word}. To add a new target, delete one of the existing ones in the Settings, or switch to the Premium plan to analyze an unlimited number of targets.',
                'settingsLabel': 'Settings',
                'hideLabel': 'Hide',
                'targetWordForm1': 'target',
                'targetWordForm2': 'targets',
                'targetWordForm3': 'targets',
            },
            'authRequiredAlert': {
                'unknownError': 'Something has gone wrong...',
                'privateAccountLabel': 'Private account',
                'errorDescription': 'You need to log in using any account currently following <span>@{username}</span> in order to track it. <br /><br /> This is simply required to retrieve data from Instagram. The user is not going to discover that you are watching him.',
                'authorizeToSpy': 'Authorize and track ',
                'importantNote': 'Important: Don\'t forget to disable two-factor authentication!',
                'loginPlaceholder': 'Account login',
                'passwordPlaceholder': 'Account password',
            },
            'bindCard': {
                'wrongEmailFormatError': 'Invalid email format',
                'unableToCreatePasswordRecoveryRequest': 'Password reset request failed; please contact technical support!',
                'titleLabel': 'Discover as much as possible about the person you\'re interested in for just 1$',
                'description': 'Follow 7 types of user activity: Likes, Comments, Stories, Followings, Followers, Posts and Reels, Admirers. Just {bindCardPrice}{bindCardCurrency} per day. <br><br>The user is never going to discover that you are watching him!',
                'termsAcceptanceLabel': 'I agree to <a href="/terms_instashpion.pdf" target="_blank" class="card-bind-block__agreement-link">the User Agreement</a>',
                'emailInputPlaceholder': 'Your email to receive a receipt...',
                'tryForFreeLabel': 'Try for free',
                'emailExistsError': 'The email submitted <span class="card-bind-block__form-error-span tail__error-span">{email}</span> has already been registered. Try logging in using the specified email. <br/> Forgot password? Get a password recovery link at the provided email.',
                'recoverPasswordBtnLabel': 'Recover your password',
                'disclaimer': 'After the trial period ends, the subscription fee is {price}₽ per each {period} days, debited from the provided bank card. You can cancel the subscription any time you want.',
            },
            'cancelSubscriptionModal1': {
                'title': 'Attention: cancellation of subscription',
                'description': 'You can now use the service\'s entire features without any limitations. Don\'t forget to manually update the data every day to get the most recent information. You can cancel your subscription until {paidTill}.',
                'keepMonitoringQuestion': 'Do you want to continue tracking the account?',
                'yes': 'Yes, continue',
                'no': 'Cancel subscription',
            },
            'cancelSubscriptionModal2': {
                'title': 'Attention: functional limitations',
                'description': 'We must inform you that stopping your DataJam subscription would disable some tracking features, including Stories, Followings, Posts, and Admirers.',
                'areYouSure': 'Do you really want to completely abandon these useful features along with your subscription to the service?',
                'yes': 'Cancel the subscription',
                'no': 'No, continue',
            },
            'cancelSubscriptionModal3': {
                'title': 'Cancellation of subscription',
                'description': 'Who knows what secrets your target may reveal next week? If you stop tracking right now, you may miss something significant. We suggest that you do not give up halfway and <span>offer a {discountValue}% discount</span> on the next debit.',
                'descriptionPart2': 'As a result, you will pay {discountedPrice}$ for the next week.',
                'getDiscountLabel': 'Get a discount',
                'cancelSubscription': 'Cancel the subscription',
            },
            'cancelSubscriptionModal4': {
                'title': 'Free access for an active subscription',
                'description': 'In addition to all the advantages that an active subscription gives, we are offering you <span>+{freeSubscriptionDays} days</span> of access to DataJam for free!',
                'descriptionPart2': 'We sincerely hope that throughout this time you will appreciate the service\'s unique range of features!',
                'getFreePeriodLabel': 'Get +{freeSubscriptionDays} days of access',
                'cancelSubscription': 'Cancel the subscription',
            },
            'changeTempPasswordAlert': {
                'title': 'Change the user password',
                'description': 'A randomly generated password was issued to you during registration and sent to the email you provided. We recommend that you change it to your own.',
                'changePasswordBtnLabel': 'Change password',
                'keepPasswordBtnLabel': 'Keep it',
            },
            'checkpointAlert': {
                'title': 'Verification is required ',
                'description': 'The authorization attempt has been interrupted by Instagram. <br/><br/> A confirmation code has been sent to your phone number - enter it in the field below and click \'Continue\'',
                'continueBtnLabel': 'Continue',
                'warning': 'Important: Don\'t forget to disable two-factor authentication!',
                'cancel': 'Cancel the authorization',
            },
            'twoFactorAlert': {
                'title': 'Two-factor authentication required',
                'description': 'Two-factor authentication has to be disabled!',
                'continueBtnLabel': 'Continue',
                'cancel': 'Cancel the authorization',
            },
            'footer': {
                'contactNumber': '+15853042399',
                'contactNumberString': '+1(585)-304-23-99',
                'serviceName': 'DataJam',
                'contactAddress': 'UAB "Euroneka"<br />62 Harrison Ave,<br />Montclair, NJ 07042<br />USA',
                'privacyRules': 'Privacy policy',
                'userTerms': 'User Agreement',
                'refundPolicy': 'Refund policy',
                'disclaimer': ' ',
            },
            'freeAdditionalTrialModal': {
                'title': 'Access has been successfully prolonged for +{days} days! !',
                'description': 'Great! You can now use the service\'s entire features without any limitations for even longer.',
                'goToDashboard': 'Go to the Dashboard',
            },
            'invalidSubscriptionAlert': {
                'title': 'The category is not available.<br>Subscription error',
                'description': 'Some functionality is restricted due to an inactive subscription. Please renew your subscription or pay for a new plan.',
                'selectPlanBtnLabel': 'Choose a plan',
            },
            'missingDataAlert': {
                'inProgressMessage': 'Data on the activity of your target is being analyzed and will be available soon!',
                'availableOnReanalyzeOnly': '"This category is currently missing any data since it could not be gathered <span class="feed-status__text-span">during the initial analysis</span>. The data in this and other categories will appear <span class="feed-status__text-span">after the next activity analysis.</span>',
                'noDataAvailable': 'We have nothing to display for this category since there have been no changes or data is missing',
                'noDataAvailableState': 'We have nothing to display for this category since there have been no changes or data is missing',
                'noDataAvailableUpdate': ''
            },
            'passwordErrorAlert': {
                'unknownError': 'Something has gone wrong...',
                'title': 'Incorrect data',
                'description': 'Failed to log in to the span>@{handlerUsername}</span> account added to track <span>@{targetUsername}</span>. Please try again',
                'loginInputPlaceholder': 'Account login',
                'passwordInputPlaceholder': 'Account password',
                'authorize': 'Authorize and track ',
                'warning': 'Important: Don\'t forget to disable two-factor authentication!',
            },
            'recoverSubscriptionBlock': {
                'title': 'Subscription management',
                'description': 'Do you want to renew your subscription to the service before {paidTill}?',
                'reviveBtnLabel': 'Renew the subscription',
            },
            'restartRequiredAlert': {
                'title': 'Something has gone wrong...',
                'description': 'For unknown reasons, something prevented you from running the analysis using the account you provided.<br /><br /> Most likely, the problem is on Instagram\'s side.<br /><br /> Go to Instagram and follow their instructions, or restart the analysis.',
                'startAnalyze': 'Run the analysis',
                'goToInstagram': 'Go to Instagram',
            },
            'settingsTargetInfoBlock': {
                'dayForm1': 'day',
                'dayForm2': 'days',
                'dayForm3': 'days',
                'hoursShort': 'h.',
                'deletionAvailableAt': '{days} {dayForm} {hours} h. {minutes} min.',
                'targetLabel': 'target',
                'removeLabel': 'Delete',
                'deletionAvailableInLabel': '<span>@{username}</span> @my_target_acc deletion will be available after ',
                'targetDeletionBlockTitle': 'Target deletion @{username}',
                'targetDeletionConfirm': 'Are you sure you want to delete your target <span>@{username}</span> and stop receiving activity information?',
                'confirmDelete': 'Yes, delete',
                'cancelDelete': 'No, don\'t delete',
            },
            'settingHandlerInfo': {
                'editButtonLabel': 'Edit',
                'accountLabel': 'my account',
                'editDataLabel': 'Edit data',
                'editFormDescription': 'Измените данные своего аккаунта <span>@{username}</span>, например при возникновении ошибки авторизации (неверный пароль).',
                'loginPlaceholder': 'Account login',
                'passwordPlaceholder': 'Account password',
                'updateHandler': 'Edit data',
                'deleteHandlerButton': 'Delete this account',
                'targetDeletionBlockTitle': 'Delete account @{username}',
                'deleteFormHandlerDescription': 'Вы уверены, что хотите удалить аккаунт <span>@my_second_account</span>>? После этого, для слежки за приватными целями потребуется добавить другой аккаунт, подписанный на эти цели',
                'confirmDelete': 'Yes, delete',
                'cancelDelete': 'No, don\'t delete',
            },
            'targetInfoBlock': {
                'targetLabel': 'target',
                'followsCountLabel': 'Follows',
                'followersCountLabel': 'Followers',
                'postsCountLabel': 'Posts',
                'addNewTarget': 'Add the target',
            },
            'viewPhotoModal': {
                'newItemPublishedLabel': 'A new photo has been published',
                'newLikeLabel': 'Post like',
                'newCommentLabel': 'Post comment',
                'publishDateLabel': 'Publishing date',
                'closeLabel': 'Close',
                'viewInInstagram': 'View on Instagram',
            },
            'viewVideoModal': {
                'newItemPublishedLabel': 'A new video has been published',
                'newLikeLabel': 'Post like',
                'newCommentLabel': 'Post comment',
                'publishDateLabel': 'Publishing date',
                'closeLabel': 'Close',
                'viewInInstagram': 'View on Instagram',
            },
            'setupNotificationsAlert': {
                'title': 'Configure notifications',
                'description': 'Enable notifications so that we can send you an email when the target\'s data collection is finished. By doing so, you always have access to the most recent data and won\'t forget to launch new data collection.',
                'setupLabel': 'Configure',
                'hideLabel': 'Hide',
            },
            'subscriptionExpiredAlert': {
                'title': 'Updates are not available.<br /> Payment error.',
                'description': 'In order to continue using all the features of DataJam, please pay for a subscription.',
                'selectTariffBtnLabel': 'Choose a plan',
            },
            'subscriptionRequiredAlert': {
                'title': 'The category is not available.<br /> Subscription error',
                'description': 'Some functionality is restricted due to an inactive subscription. Please renew your subscription or pay for a new plan',
                'selectTariffBtnLabel': 'Choose a plan',
            },
            'survey': {
                'title': 'Help us become better!',
                'description': 'Complete a brief anonymous survey',
            },
            'commentsResult': {
                'someone': 'someone',
                'fromTarget': 'Put',
                'toTarget': 'Received',
                'loadMore': 'Load more...',
                'viewFullComment': 'View all data',
                'commentIsHidden': '*Comment is hidden, to unlock - purchase any plan',
                'unlockComment': 'Show comment',
            },
            'followersResult': {
                'followEventLabel': 'Started following the target',
                'loadMore': 'Load more...',
            },
            'followsResult': {
                'followEventLabel': 'The target started following',
                'loadMore': 'Load more...',
            },
            'likersResult': {
                'someone': 'someone',
                'descriptionTitle': 'About the \'Admirers\' category',
                'description': 'Admirers are users who are not following the account you are interested in but still interact with its content (like, comment, etc.)',
                'gotIt': 'Got it!',
                'actionsCountLabel': 'Interactions',
                'loadMore': 'Load more...',
            },
            'likesResult': {
                'someone': 'someone',
                'likeTo': 'Put',
                'likeFrom': 'Received',
                'showMore': 'Show more...',
                'description': 'Admirers are users who are not following the account you are interested in but still interact with its content (like, comment, etc.)',
                'gotIt': 'Got it!',
                'actionsCountLabel': 'Interactions',
                'loadMore': 'Load more...',
            },
            'postsAndReelsResult': {
                'loadMore': 'Load more...',
            },
            'storiesResult': {
                'loadMore': 'Load more...',
            },
            'analyze': {
                'panelTitle': 'Dashboard',
            },
            'home': {
                'pageTitle': 'Dashboard',
                'pageTitleTag': 'DataJam',
            },
            'notificationSettings': {
                'pageTitle': 'Notifications',
                'pageTitleTag': 'DataJam',
                'readyBlockTitle': 'Data availability',
                'readyBlockDescription': 'After all the data is collected and DataJam is ready for a new analysis, a notification will be sent to your email <span>{email}</span>.',
                'reportsBlockTitle': 'Events Report',
                'reportsBlockDescription': 'Configure notifications about new events in the tracked accounts. A summary of the changes noticed by DataJam during the specified period in your Target\'s account will be sent to you.',
                'byMailLabel': 'Email',
                'byTelegramLabel': 'Telegram',
                'reportsPeriodLabel': 'Send reports interval:',
                'everyDayLabel': 'Daily',
                'everyThreeDaysLabel': 'Every 3 days',
                'everyWeekLabel': 'Weekly',
                'everyMonthLabel': 'Monthly',
                'telegramSettingsBlockTitle': 'Telegram-notifications',
                'telegramOnlyForPremiumDisclaimer': 'Telegram notifications are available only to Premium plan users',
                'aboutPremiumTariffLabel': 'about plan',
                'telegramSettingsBlockDescription': 'To enable Telegram-notifications you need to activate <span>Telegram</span>, toggler, than copy your PIN',
                'telegramSettingsBlockDescriptionPart2': 'and use it to activate bot',
                'telegramSettingsBlockBotName': '@zengram_instashpion_bot',
            },
            'order': {
                'payBtnLabel': 'Pay',
            },
            'orderSuccess': {
                'panelTitle': 'Payment',
                'title': 'Order paid successfully!',
                'description': 'Thank you for the purchase!<br /> Now you can start analyzing your target!',
                'startAnalyzeBtnLabel': 'Run the analysis',
                'specialOfferTitle': 'Hot Offer! 🔥',
                'specialOfferSubtitle': 'You can get discounts only on this page:',
                'specialOfferBannerTitle': 'PREMIUM',
                'specialOfferBannerDescription': 'More opportunities:<br /><br />- Targets are not limited<br />- notifications via Telegram<br /> - Improved algorithms',
                'specialOfferBannerBuyBtnLabel': 'Purchase',
                'specialOfferBannerCurrentPrice': '2 699₽',
                'specialOfferBannerOldPrice': '2 999₽',
                'specialOfferDisclaimer': 'By paying for full access to the service with your bank card, you accept the terms of <a href="/terms_instashpion.pdf" class="special-offer__link">the User Agreement</a>',
            },
            'settings': {
                'pageTitle': 'Settings',
                'pageTitleTag': 'DataJam',
                'promoCodeSuccessMsg': 'Promo code applied successfully!',
                'passwordsNotEqualError': 'Passwords do not match!',
                'oldPasswordNotEnteredError': '"Old password" is empty!',
                'newPasswordNotEnteredError': '"New password" is empty',
                'tooShortOldPasswordError': '"Old password" is too short!',
                'tooShortNewPasswordError': '"New password" is too short!',
                'accountSettingsTitle': 'User settings',
                'changePasswordLabel': 'Password change',
                'oldPasswordPlaceholder': 'Enter old password...',
                'newPasswordPlaceholder': 'Enter new password...',
                'newPasswordRepeatPlaceholder': 'Repeat password...',
                'passwordChangeDescription': 'A randomly generated password was issued to you during registration and sent to the email you provided. We recommend that you change it to your own.',
                'saveBtnLabel': 'Save',
                'saveSuccessMessage': 'Data saved successfully',
                'targetsControlTitle': 'Targets management',
                'targetsControlDescription': 'The target can be deleted 7 days after its initial analysis.',
                'promoCodeSettingsTitle': 'Promo code',
                'promoCodeInputPlaceholder': 'Enter you promo code',
                'activateBtnLabel': 'Activate',
            },
            'tutorial': {
                'pageTitle': 'Guide',
                'pageTitleTag': 'DataJam | Guide',
                'pageMetaDescription': 'DataJam | Guide',
            },
            'subscription': {
                'payForAccess': 'Prices and Subscription',
                'pageTitle': 'Plans',
                'pageTitleTag': 'DataJam',
                'daysText': 'days',
                'unknownError': 'Something has gone wrong...',
                'totalTargetsLabel': 'Accounts added',
                'paidTillLabel': 'Valid until',
                'currentTariffLabel': 'Your current plan',
                'subscriptionRecoveredSuccessfully': 'Your subscription has been successfully renewed!',
                'subscriptionRecoveredDescription': 'You can now use all features and functions without any limitations.',
                'subscriptionControlLabel': 'Subscription management',
                'currentSubscriptionTariffDescription': 'Subscription to the {subscriptionTariffName} plan for {subscriptionPrice}$ is enabled and will be valid until {paidTill}. After that, the subscription will be automatically renewed.',
                'goToHomeBtnLabel': 'Return to dashboard',
                'cancelSubscriptionBtnLabel': 'Cancel the subscription',
                'tariffIsActiveLabel': 'ACTIVE',
                'isRecommendedLabel': 'Recommended',
                'isActiveLabel': 'CURRENT',
                'isSelectedLabel': 'selected',
                'notSelectedLabel': 'select',
                'currencySymbol': '$',
                'shortMonthLabel': 'mon',
                'yourChoiceLabel': 'You have selected',
                'termsAcceptanceLabel': 'I agree to <a href="/terms" target="_blank" class="plans__confirm-agreement-link">User Agreement</a>',
                'buyBtnLabel': 'Buy',
                'selectTariffLabel': 'Select plan, you\'d like to purchase',
                'availablePlansDescription': '7-days and 1-month plans include monitoring of 3 accounts.',
                '7daysPlan': {
                    'period': '7 days',
                    'price': ' ',
                    'fullDescription': '7-days Plan:<br /> Full activity monitoring of 3 accounts for {totalPrice}$ per 7 days',
                },
                '1monthPlan': {
                    'period': '1 month',
                    'fullDescription': '1-month Plan:<br /> Full activity monitoring of 3 accounts for {totalPrice}$ per 1 month',
                },
                '6monthsPlan': {
                    'period': '6 months',
                    'price': ' ',
                    'fullDescription': '6-months Plan:<br /> Full activity monitoring of 3 accounts for {totalPrice}$ per 6 months',
                },
                'premiumPlan': {
                    'title': 'PREMIUM',
                    'description': 'Advanced features:<br /> - Unlimited number of Targets<br /> - Personal manager<br /> - Improved activity tracking algorithms<br /> - Notifications via Telegram',
                    'aboutTariffBtnLabel': 'More about the plan',
                    'fullDescription': 'Premium plan.<br /> After the purchase, you will have the opportunity to add an unlimited number of targets for tracking, contact your personal technical Support manager, and have newly improved tracking algorithms activated for you for {totalPrice}₽ per 30 days',
                },
            },
            'freeAccessAlert': {
                'title': 'The data is partially hidden',
                'expiredDescription1': 'You are using free access, so the data is partially hidden. ',
                'expiredDescription2': 'To get access to all the data, choose any of the paid-for plans',
                'selectPlanBtnLabel': 'Choose a plan',
                'continueMonitoringBtnLabel': 'Continue monitoring',
                'continueMonitoringDescription': 'In order to continue tracking your Target and reveal the hidden data, you must subscribe to any of the plans',
            },
            'freeAccessDataHiddenAlert': {
                'title': 'The data is hidden',
                'description': 'To get access to the hidden data, you must subscribe to any of the plans',
                'selectPlanBtnLabel': 'Choose a plan',
            },
            'freeAccessUnlockDataAlert': {
                'title': 'Activity analysis ',
                'lastRefreshDate': 'Last updated',
                'unlockDataBtnLabel': 'Unlock data',
            },
            'surveyOnCancelSubscriptionModal': {
                'title': 'DataJam\'s team is here!',
                'description': 'Thank you for using DataJam. We want the service to be better and more useful for you, so your feedback is important! Complete a short survey (it won\'t take more than 5 minutes) and we\'ll listen to what you want. And if you agree to be interviewed, we\'ll give you free access to the service for a whole week!',
                'submitBtnLabel': 'Answer the survey',
            },
            'enCancelSubscriptionModal': {
                'title': 'Attention: cancellation of subscription',
                'description': 'You can now use the service\'s entire features without any limitations.<br />Don\'t forget to manually update the data every day to get the most recent information.<br />You can cancel your subscription until {paidTill}.<br /><br />Do you want to continue tracking the account?',
                'yes': 'Yes, continue',
                'no': 'Cancel subscription'
            },
            'payment': {
                "form": {
                    "backButton": "Back",
                    "formTitle": "Checkout",
                    "cardNumberInputLabel": "Pay with credit / debit card",
                    "cardNumberInputPlaceholder": "Card number",
                    "expiryDateInputPlaceholder": "MM / YY",
                    "cvcInputPlaceholder": "CVC",
                    "countrySelectLabel": "Country",
                    "countrySelectPlaceholder": "Select country",
                    "recurringWTrialPolicyAcceptanceLabel": "By clicking on the \"Pay\" button and making a payment, you agree to the <a class=\"link\" href=\"{userAgreementUrl}\" target=\"_blank\"><b>User agreement</b></a><!-- and <a class=\"link\" href=\"{privacyPolicyUrl}\" target=\"_blank\"><b>Privacy policy</b></a>-->. You also agree to automatic renewal of your subscription through recurring payments. After the trial period ({trialPeriod} day(s)), the subscription fee for the service will be {currencySign}{subscriptionValue}/{subscriptionPeriod} days. You can cancel your subscription at any time.",
                    "recurringPolicyAcceptanceLabel": "By clicking on the \"Pay\" button and making a payment, you agree to the <a class=\"link\" href=\"{userAgreementUrl}\" target=\"_blank\"><b>User agreement</b></a><!-- and <a class=\"link\" href=\"{privacyPolicyUrl}\" target=\"_blank\"><b>Privacy policy</b></a>-->. You also agree to automatic renewal of your subscription through recurring payments. Subscription fee for the service will be {currencySign}{subscriptionValue}/{subscriptionPeriod} days. You can cancel your subscription at any time.",
                    "policyAcceptanceLabel": "By clicking on the \"Pay\" button and making a payment, you agree to the <a class=\"link\" href=\"{userAgreementUrl}\" target=\"_blank\"><b>User agreement</b></a><!-- and <a class=\"link\" href=\"{privacyPolicyUrl}\" target=\"_blank\"><b>Privacy policy</b></a>-->. And also agree to an automatically renewable subscription to the service",
                    "payButtonText": "Pay {currencySign}{amount} {currencyCode}",
                    "footer": "<b>All pricing is in {currencyCode}</b>. If paying with a different currency, the billed amount is subject to exchange rates and additional fees.",
                    "errorOnCardConfirm": "Unable to confirm card",
                    "unknownError": "Unknown error",
                },
                "success": {
                    "paymentSucceedMessageLine1": "The payment is successful.",
                    "paymentSucceedMessageLine2": "Now you can use the service.",
                    "startUsingLabel": "Start using",
                },
                "stripe": {
                    "cardNumberPlaceholder": "Card number",
                    "cardNumberIsEmpty": "Empty card number",
                    "cardExpiryIsEmpty": "Card expiry is empty",
                    "cardCvcIsEmpty": "Card CVC is empty",
                },
            }
        },
        'ru-RU': {
            'main': {
                pageTitle: null,
                pageTitleTag: 'Инсташпион',
                pageMetaDescription: 'Анализ активности инстаграм аккаунтов',
                pageLinkCanonical: 'https://instashpion.ru/instashpion/dashboard',
                'termsLink': '/terms_instashpion.pdf',
                'privacyLink': '/privacy.pdf',
            },
            'header': {
                'menuLabel': 'Меню',
                'homeLabel': 'Главная',
                'addAccountLabel': 'Добавить аккаунт',
                'tutorialsLabel': 'Инструкция',
                'subscriptionLabel': 'Тарифы и подписка',
                'supportLabel': 'Тех. поддержка',
                'notificationsLabel': 'Уведомления',
                'settingsLabel': 'Настройки',
                'affilateProgramLabel': 'Партнерская программа',
                'logOutLabel': 'Выход',
                'accountLabel': 'Аккаунт',
                'logo': '/spy20-lk/img/instashpion-logo.svg',
                'logoSmall': '/spy20-lk/img/instashpion-logo-small.svg',
                'affiliateProgramUrl': 'https://zencpa.ru/',
            },
            'addAccount': {
                'pageTitle': 'Новая цель',
                'pageTitleTag': 'Инсташпион',
                'blockTitle': 'Анализ активности',
                'blockDescription': 'Для начала анализа добавьте интересующий вас аккаунт. Вставьте ссылку или введите название аккаунта:',
                'addButtonLabel': 'Добавить цель',
                'searchingLabel': 'Поиск...',
                'error': 'Ошибка',
                'inputPlaceholder': '@username или ссылка',

                'titleAndDescription': 'название и описание',
                'likes': 'лайки',
                'comments': 'комментарии',
                'posts': 'публикации',
                'postsMarks': 'отметки на фото',
                'followsAndFollowers': 'подписки и подписчики',
            },
            'analyzeControl': {
                'addButtonLabel': 'Добавить цель',
                'blockTitle': 'Анализ активности',
                'blockInitialDescription': 'Запустите первый сбор данных прямо сейчас!',
                'startAnalyzeBtnLabel': 'Запустить анализ',
                'categoriesListTitle': 'Разделы',
                'likesCategoryTitle': 'Лайки',
                'followsCategoryTitle': 'Подписки',
                'followersCategoryTitle': 'Подписчики',
                'likersCategoryTitle': 'Поклонники',
                'storiesCategoryTitle': 'Stories',
                'commentsCategoryTitle': 'Комментарии',
                'postsAndReelsCategoryTitle': 'Посты и Reels',
                'startAnalyzeBtnDescription': 'Чтобы получить данные по активности вашей цели - нажмите на кнопку <span class="feed-status__text-span">Запустить анализ</span>',
                'lastUpdateDate': 'Дата обновления',
                'timeTillNextUpdate': 'Следующее обновление данных будет доступно через',
                'reanalyzeBtnLabel': 'Обновить',
                'analyzeInProgressDescription': 'Анализ аккаунта в процессе и займет некоторое время.<br />Загляните сюда чуть позже...',
                'analyzeInProgressStatus': 'Идёт сбор...',
                'previousCategoryLabel': 'Предыдущий раздел',
                'nextCategoryLabel': 'Следующий раздел',
            },
            'analyzeLimitAlert': {
                'disclaimer': 'Вы можете анализировать только {limit} {target_word}. Чтобы добавить новую цель - удалите одну из имеющихся в разделе Настройки.',
                'settingsLabel': 'Настройки',
                'hideLabel': 'Скрыть',
                'targetWordForm1': 'цель',
                'targetWordForm2': 'цели',
                'targetWordForm3': 'целей',
            },
            'authRequiredAlert': {
                'unknownError': 'Что-то пошло не так...',
                'privateAccountLabel': 'Приватный аккаунт',
                'errorDescription': 'Для того, чтобы следить за <span>@{username}</span> нужно авторизоваться через любой аккаунт, подписанный на него. <br /><br /> Это нужно только для получения данных из Инстаграм, пользователь <span>никогда</span> не узнает, что вы шпионите за ним.',
                'authorizeToSpy': 'Авторизоваться и следить',
                'importantNote': 'Важно: не забудьте отключить двухфакторную аутентификацию!',
                'loginPlaceholder': 'Логин аккаунта',
                'passwordPlaceholder': 'Пароль аккаунта',
            },
            'bindCard': {
                'wrongEmailFormatError': 'Неверный формат email',
                'unableToCreatePasswordRecoveryRequest': 'Не удалось запросить сброс пароля, обратитесь в тех. поддержку!',
                'titleLabel': 'Узнайте всё об интересующем человеке всего за 1₽',
                'description': 'Следите за 7 типами активности пользователя: лайки, комментарии, Stories, подписки, подписчики, поcты и Reels, поклонники. Всего {bindCardPrice}{bindCardCurrency} за сутки. <br><br>Пользователь никогда не узнает, что вы наблюдаете за ним!',
                'termsAcceptanceLabel': 'Я согласен(-на) с <a href="/terms_instashpion.pdf" target="_blank" class="card-bind-block__agreement-link">Договором оферты</a>',
                'emailInputPlaceholder': 'Ваш e-mail для получения чека...',
                'tryForFreeLabel': 'Попробовать бесплатно',
                'emailExistsError': 'Указанный вами адрес эл.почты <span class="card-bind-block__form-error-span tail__error-span">{email}</span> уже был зарегистрирован в сервисе. Попробуйте авторизоваться, используя указанную эл.почту. <br/> Забыли пароль? Получите ссылку для восстановления пароля на указанный адрес эл.почты.',
                'recoverPasswordBtnLabel': 'Восстановить пароль',
                'disclaimer': 'После тестового периода стоимость подписки на сервис Инсташпион составит {price}₽ за каждые {period} дней использования, списание будет производиться с указанной банковской карты. Вы вправе отказаться от использования платной подписки в любое время.',
            },
            'changeTempEmailModal': {
                'title': 'Введите ваш e-mail адрес',
                'description': 'Для запуска анализа необходимо завершить  регистрацию. Укажите вашу почту, на которую будет отправлено письмо с данными для входа, а также будут проходить уведомления о завершении анализа.',
                'inputPlaceholder': 'Ваш e-mail для регистрации',
                'submitBtnLabel': 'продолжить',
            },
            'cancelSubscriptionModal1': {
                'title': 'Внимание: отмена подписки',
                'description': 'Сейчас вы имеете полный доступ ко всему функционалу сервиса без каких-либо ограничений. Для получения актуальных данных не забывайте обновлять их каждый день вручную. Вы можете отменить подписку до {paidTill}.',
                'keepMonitoringQuestion': 'Хотите продолжить мониторинг аккаунта?',
                'yes': 'да, продолжить',
                'no': 'отменить подписку',
            },
            'cancelSubscriptionModal2': {
                'title': 'Внимание: ограничение части функционала',
                'description': 'Вынуждены предупредить, что отказ от подписки на сервис Инсташпион заблокирует для вас часть функций для отслеживания, такие как Истории, Подписки, Посты и Поклонники.',
                'areYouSure': 'Вы действительно хотите отказаться от данного полезного функционала вместе с подпиской на сервис?',
                'yes': 'Отменить подписку',
                'no': 'Нет, продолжить',
            },
            'cancelSubscriptionModal3': {
                'title': 'Отмена подписки',
                'description': 'Кто знает, какие тайны вашей цели могут быть раскрыты на следующей неделе? Если вы остановите слежку сейчас - можете пропустить что-то важное. Предлагаем вам не бросать начатое дело и <span>дарим скидку {discountValue}%</span> на следующее списание.',
                'descriptionPart2': 'В итоге цена на следующую неделю для вас составит {discountedPrice}₽.',
                'getDiscountLabel': 'Получить скидку',
                'cancelSubscription': 'отменить подписку',
            },
            'cancelSubscriptionModal4': {
                'title': 'Бесплатный доступ за активную подписку',
                'description': 'Плюсом ко всем преимуществам, которые дает активная подписка, мы подарим вам <span>+{freeSubscriptionDays} дней доступа</span> к Инсташпиону совершенно бесплатно!',
                'descriptionPart2': 'Надеемся, за это время вы оцените весь уникальный набор функций сервиса!',
                'getFreePeriodLabel': 'Получить +{freeSubscriptionDays} дней доступа',
                'cancelSubscription': 'отменить подписку',
            },
            'changeTempPasswordAlert': {
                'title': 'Смените пароль от учетной записи',
                'description': 'При регистрации вам был присвоен сгенерированный пароль и отправлен на указанную почту. Мы рекомендуем сменить его на свой собственный',
                'changePasswordBtnLabel': 'сменить пароль',
                'keepPasswordBtnLabel': 'оставить',
            },
            'checkpointAlert': {
                'title': 'Пройти верификацию',
                'description': 'Попытка авторизации была прервана Инстаграмом. <br><br> На ваш номер телефона был отправлен код подтверждение - введите его в поле ниже и нажмите "Продолжить"',
                'continueBtnLabel': 'продолжить',
                'warning': 'Важно: не забудьте отключить двухфакторную аутентификацию!',
                'cancel': 'отменить авторизацию',
            },
            'notFriendAlert': {
                'title': 'Нет подписки на цель',
                'description': 'Мы не можем получить данные об активности приватной цели, так как аккаунт, который вы добавили, не является подписчиком этой цели.' +
                    '<br><br>Пожалуйста, либо подпишитесь на цель этим аккаунтом, дождитесь, когда цель примет подписку и нажмите “Попробовать снова”, либо добавьте другой, которым вы точно подписаны на цель.',
                'try': 'попробовать снова',
                'change': 'добавить другой аккаунт',
            },
            'rateLimitError': {
                'title': 'Пауза действий',
                'description': 'К сожалению, Инстаграм включил временную паузу запросов (rate-limit) для добавленного аккаунта.' +
                '<br><br>Как правило эта пауза длится от 15 минут до суток.' +
                    '<br><br>Попробуйте добавить другой аккаунт или повторите попытку позже.',
                'change': 'изменить аккаунт',
                'try': 'повторить попытку',
            },
            'twoFactorAlert': {
                'title': 'Двухфакторная аутентификация',
                'description': 'Для того, чтобы мы могли выполнить вход в ваш аккаунт и получить данные о цели, необходимо отключить двухфакторную аутентификацию у аккаунта @{login}.' +
                    '<br><br>Перейдите в настройки приложения Инстаграм и временно отключите двухфакторную аутентификацию.' +
                    '<br><br>После выключения - нажмите на кнопку “ОК, я отключил” ниже.',
                'try': 'ОК, я отключил',
                'change': 'отменить авторизацию',
            },
            'footer': {
                'contactNumber': '+74994600332',
                'contactNumberString': '+7 (499) 460-03-32',
                'serviceName': 'Инсташпион',
                'contactAddress': 'Пресненская наб., 12, БЦ, Москва',
                'privacyRules': 'Политика конфиденциальности',
                'userTerms': 'Пользовательское соглашение',
                'refundPolicy': 'Политика возвратов',
                'disclaimer': '* Принадлежит организации Meta, признанная судом в РФ экстремистской. Данные меры судебной защиты не ограничивают действий по использованию программных продуктов компании Meta физических и юридических лиц, не принимающих участия в запрещенной законом деятельности.',
            },
            'freeAdditionalTrialModal': {
                'title': 'Доступ успешно продлен на +{days} дней!',
                'description': 'Отлично! Теперь вы можете еще дольше пользоваться всеми функциями сервиса Инсташпион без каких-либо ограничений.',
                'goToDashboard': 'Вернуться на дашборд',
            },
            'invalidSubscriptionAlert': {
                'title': 'Раздел недоступен.<br>Ошибка подписки',
                'description': 'Часть функционала закрыта из-за неактивной подписки, пожалуйста, возобновите подписку или оплатите новый тариф',
                'selectPlanBtnLabel': 'выбрать тариф',
            },
            'missingDataAlert': {
                'inProgressMessage': 'Данные по активности вашей цели в процессе анализа и появятся в ближайшее время!',
                'availableOnReanalyzeOnly': 'В этом разделе сейчас нет данных, т.к. они не могут быть собраны <span class="feed-status__text-span">во время первого анализа</span>. Данные в этом разделе и в некоторых других появятся <span class="feed-status__text-span">после второго анализа активности</span>.',
                'noDataAvailable': 'Нам нечего показать по этой категории, так как по ней не было изменений или данные отсутствуют',
                'noDataAvailableState': 'По этой категории Инсташпион не нашёл обновлений у цели.',
                'noDataAvailableUpdate': 'Обновите данные позже, чтобы увидеть изменения.'
            },
            'passwordErrorAlert': {
                'unknownError': 'Что-то пошло не так...',
                'title': 'Неверные данные',
                'description': 'Не удалось авторизоваться в аккаунт <span>@{handlerUsername}</span>, добавленный для получения данных о <span>@{targetUsername}</span>. <br /><br /> Попробуйте ещё раз',
                'loginInputPlaceholder': 'Логин аккаунта',
                'passwordInputPlaceholder': 'Пароль аккаунта',
                'authorize': 'авторизоваться и следить',
                'warning': 'Важно: не забудьте отключить двухфакторную аутентификацию!',
            },
            'recoverSubscriptionBlock': {
                'title': 'Управление подпиской',
                'description': 'Хотите возобновить подписку на сервис до {paidTill}?',
                'reviveBtnLabel': 'возобновить подписку',
            },
            'restartRequiredAlert': {
                'title': 'Что-то пошло не так...',
                'description': 'По неизвестным причинам, что-то помешало запустить анализ с помощью вашего аккаунта. <br /><br /> Скорее всего проблема на стороне Инстаграма. <br /><br /> Перейдите в Инстаграм и следуйте их инструкциям или перезапустите анализ.',
                'startAnalyze': 'запустить анализ',
                'goToInstagram': 'Перейти в инстаграм',
            },
            'settingsTargetInfoBlock': {
                'dayForm1': 'день',
                'dayForm2': 'дня',
                'dayForm3': 'дней',
                'hoursShort': 'ч.',
                'deletionAvailableAt': '{days} {dayForm} {hours} ч. {minutes} мин.',
                'targetLabel': 'цель',
                'removeLabel': 'удалить',
                'deletionAvailableInLabel': 'Удаление <span>@{username}</span> будет доступно через',
                'targetDeletionBlockTitle': 'Удаление цели @{username}',
                'targetDeletionConfirm': 'Вы уверены, что хотите удалить цель <span>@{username}</span> и перестать получать информацию об активности?',
                'confirmDelete': 'да, удалить',
                'cancelDelete': 'Не удалять',
            },
            'settingHandlerInfo': {
                'editButtonLabel': 'изменить',
                'accountLabel': 'мой аккаунт',
                'editDataLabel': 'Изменение данных',
                'editFormDescription': 'Измените данные своего аккаунта <span>@{username}</span>, например при возникновении ошибки авторизации (неверный пароль).',
                'loginPlaceholder': 'Логин аккаунта',
                'passwordPlaceholder': 'Пароль аккаунта',
                'updateHandler': 'изменить данные',
                'deleteHandlerButton': 'Удалить этот аккаунт',
                'targetDeletionBlockTitle': 'Удаление аккаунта @{username}',
                'deleteFormHandlerDescription': 'Вы уверены, что хотите удалить аккаунт <span>@{username}</span>? После этого, для слежки за приватными целями потребуется добавить другой аккаунт, подписанный на эти цели',
                'confirmDelete': 'да, удалить',
                'cancelDelete': 'Не удалять',
            },
            'targetInfoBlock': {
                'targetLabel': 'цель',
                'followsCountLabel': 'Подписок',
                'followersCountLabel': 'Подписчиков',
                'postsCountLabel': 'Публикаций',
                'addNewTarget': 'Добавить новую цель',
            },
            'viewPhotoModal': {
                'newItemPublishedLabel': 'Опубликовано новое фото',
                'newLikeLabel': 'Лайк на пост',
                'newCommentLabel': 'Коммент на пост',
                'publishDateLabel': 'Дата публикации',
                'closeLabel': 'закрыть',
                'viewInInstagram': 'смотреть в инстаграм',
            },
            'viewVideoModal': {
                'newItemPublishedLabel': 'Опубликовано новое видео',
                'newLikeLabel': 'Лайк на пост',
                'newCommentLabel': 'Комментарий на пост',
                'publishDateLabel': 'Дата публикации',
                'closeLabel': 'закрыть',
                'viewInInstagram': 'смотреть в инстаграм',
            },
            'setupNotificationsAlert': {
                'title': 'Настройте уведомления',
                'description': 'Включите напоминание, чтобы мы сообщили вам на почту о завершении сбора данных по цели. Так вы увидите самую актуальную информацию и не забудете запустить новый сбор.',
                'setupLabel': 'настроить',
                'hideLabel': 'скрыть',
            },
            'subscriptionExpiredAlert': {
                'title': 'Обновления недоступны.<br /> Ошибка платежа',
                'description': 'Для того, чтобы снова воспользоваться всеми функциями Инсташпиона, пожалуйста оплатите подписку.',
                'selectTariffBtnLabel': 'выбрать тариф',
            },
            'subscriptionRequiredAlert': {
                'title': 'Раздел недоступен.<br /> Ошибка подписки',
                'description': 'Часть функционала закрыта из-за неактивной подписки, пожалуйста, возобновите подписку или оплатите новый тариф',
                'selectTariffBtnLabel': 'выбрать тариф',
            },
            'survey': {
                'title': 'Помогите нам стать лучше!',
                'description': 'Пройдите небольшой анонимный опрос',
            },
            'commentsResult': {
                'someone': 'кое-кто',
                'fromTarget': 'Поставил(а) цели',
                'toTarget': 'Получил(а) от цели',
                'loadMore': 'Загрузить ещё',
                'viewFullComment': 'Смотреть полностью...',
                'commentIsHidden': '*Текст скрыт, чтобы открыть комментарий, активируйте любой из тарифов',
                'unlockComment': 'Открыть комментарий',
            },
            'followersResult': {
                'followEventLabel': 'Подписался(-ась) на цель',
                'loadMore': 'Загрузить ещё',
            },
            'followsResult': {
                'followEventLabel': 'Цель подписался(-ась) на',
                'loadMore': 'Загрузить ещё',
            },
            'likersResult': {
                'someone': 'кое-кто',
                'descriptionTitle': 'О разделе Поклонники',
                'description': 'Поклонники - пользователи, которые не подписаны на интересующий вас аккаунт, но все равно взаимодействуют с его контентом (лайкают, комментируют и тд.)',
                'gotIt': 'понятно!',
                'actionsCountLabel': 'Взаимодействий',
                'loadMore': 'Загрузить ещё',
            },
            'likesResult': {
                'someone': 'кое-кто',
                'likeTo': 'Поставил(а) цели',
                'likeFrom': 'Получил(а) от цели',
                'showMore': 'Показать больше...',
                'description': 'Поклонники - пользователи, которые не подписаны на интересующий вас аккаунт, но все равно взаимодействуют с его контентом (лайкают, комментируют и тд.)',
                'gotIt': 'понятно!',
                'actionsCountLabel': 'Взаимодействий',
                'loadMore': 'Загрузить ещё',
            },
            'postsAndReelsResult': {
                'loadMore': 'Загрузить ещё',
            },
            'storiesResult': {
                'loadMore': 'Загрузить ещё',
            },
            'analyze': {
                'panelTitle': 'Дашборд',
            },
            'home': {
                'pageTitle': 'Главная',
                'pageTitleTag': 'Инсташпион',
            },
            'notificationSettings': {
                'pageTitle': 'Уведомления',
                'pageTitleTag': 'Инсташпион',
                'readyBlockTitle': 'Готовность данных',
                'readyBlockDescription': 'На вашу почту <span>{email}</span> будет приходить уведомление о завершении сбора информации по цели и готовности Инсташпиона к новому сбору данных.',
                'reportsBlockTitle': 'Отчет о событиях',
                'reportsBlockDescription': 'Настройте отправку отчета о событиях на проверяемых аккаунтах. Вам будет приходить сводная информация о количестве всех событий, которые заметил Инсташпион за указанный период.',
                'byMailLabel': 'На почту',
                'byTelegramLabel': 'В Telegram',
                'reportsPeriodLabel': 'Отправлять отчет о событиях:',
                'everyDayLabel': 'Каждые сутки',
                'everyThreeDaysLabel': 'Каждые 3 суток',
                'everyWeekLabel': 'Раз в неделю',
                'everyMonthLabel': 'Раз в месяц',
                'telegramSettingsBlockTitle': 'Telegram-уведомления',
                'telegramOnlyForPremiumDisclaimer': 'Уведомления в Telegram, доступны только пользователям тарифа Premium',
                'aboutPremiumTariffLabel': 'о тарифе',
                'telegramSettingsBlockDescription': 'Для того, чтобы включить уведомления в Telegram, активируйте тумблер <span>В Telegram</span>, затем скопируйте ваш персональный код',
                'telegramSettingsBlockDescriptionPart2': 'и используйте его при активации бота',
                'telegramSettingsBlockBotName': '@zengram_instashpion_bot',
            },
            'order': {
                'payBtnLabel': 'Оплатить',
            },
            'orderSuccess': {
                'panelTitle': 'Оплата',
                'title': 'Заказ успешно оплачен!',
                'description': 'Спасибо за покупку!<br /> Теперь вы можете начать анализ вашей цели!',
                'startAnalyzeBtnLabel': 'Начать анализ',
                'specialOfferTitle': 'Горящее предложение! 🔥',
                'specialOfferSubtitle': 'Только на этой странице, вам доступны скидки:',
                'specialOfferBannerTitle': 'PREMIUM',
                'specialOfferBannerDescription': 'Больше возможностей:<br /><br />- Нет ограничений по целям<br />- Уведомления в Телеграм<br /> - Улучшенные алгоритмы',
                'specialOfferBannerBuyBtnLabel': 'купить',
                'specialOfferBannerCurrentPrice': '2 699₽',
                'specialOfferBannerOldPrice': '2 999₽',
                'specialOfferDisclaimer': 'Совершая оплату полного доступа к сервису банковской картой, вы принимаете условия <a href="/terms_instashpion.pdf" class="special-offer__link">Пользовательского соглашения</a>',
            },
            'settings': {
                'pageTitle': 'Настройки',
                'pageTitleTag': 'Инсташпион',
                'promoCodeSuccessMsg': 'Промо-код успешно применен!',
                'passwordsNotEqualError': 'Пароли не совпадают!',
                'oldPasswordNotEnteredError': 'Не заполнен "Старый пароль"!',
                'newPasswordNotEnteredError': 'Не заполнен "Новый пароль"!',
                'tooShortOldPasswordError': '"Старый пароль" слишком короткий!',
                'tooShortNewPasswordError': '"Новый пароль" слишком короткий!',
                'accountSettingsTitle': 'Настройки учетной записи',
                'changePasswordLabel': 'Смена пароля',
                'oldPasswordPlaceholder': 'Введите старый пароль...',
                'newPasswordPlaceholder': 'Введите новый пароль...',
                'newPasswordRepeatPlaceholder': 'Повторите новый пароль...',
                'passwordChangeDescription': 'После регистрации вам был присвоен и отправлен на почту сгенерированный пароль. Мы рекомендуем изменить его на собственный.',
                'saveBtnLabel': 'сохранить',
                'saveSuccessMessage': 'Данные успешно изменены',
                'targetsControlTitle': 'Управление целями',
                'targetsControlDescription': 'Возможность удалить цель появляется через 7 дней после первого анализа этой цели.',
                'promoCodeSettingsTitle': 'Промокод',
                'promoCodeInputPlaceholder': 'Введите имеющийся промокод',
                'activateBtnLabel': 'активировать',
            },
            'tutorial': {
                'pageTitle': 'Инструкция',
                'pageTitleTag': 'Инсташпион',
                'pageMetaDescription': 'Анализ активности инстаграм аккаунтов',
            },
            'subscription': {
                'payForAccess': 'Оплата доступа',
                'pageTitle': 'Тарифы',
                'pageTitleTag': 'Инсташпион',
                'daysText': 'дней',
                'unknownError': 'Что-то пошло не так...',
                'totalTargetsLabel': 'Аккаунтов добавлено',
                'paidTillLabel': 'Доступ до',
                'currentTariffLabel': 'Текущий тариф',
                'subscriptionRecoveredSuccessfully': 'Подписка успешно возобновлена!',
                'subscriptionRecoveredDescription': 'Теперь вам снова доступны все функции и возможности без ограничений.',
                'subscriptionControlLabel': 'Управление подпиской',
                'currentSubscriptionTariffDescription': 'Подписка на тариф {subscriptionTariffName} за {subscriptionPrice}₽ подключена и действует до {paidTill}. После этого произойдет автопродление подписки.',
                'goToHomeBtnLabel': 'вернуться на главную',
                'cancelSubscriptionBtnLabel': 'отменить подписку',
                'tariffIsActiveLabel': 'Действует',
                'isRecommendedLabel': 'рекомендуем',
                'isActiveLabel': 'Активен',
                'isSelectedLabel': 'выбран',
                'notSelectedLabel': 'выбрать',
                'currencySymbol': '₽',
                'shortMonthLabel': 'мес',
                'yourChoiceLabel': 'Вы выбрали',
                'termsAcceptanceLabel': 'Я согласен(-на) с <a href="/terms_instashpion.pdf" target="_blank" class="plans__confirm-agreement-link">Договором оферты</a>',
                'buyBtnLabel': 'Купить',
                'selectTariffLabel': 'Выберите тариф, который хотите оплатить',
                'availablePlansDescription': 'Тарифы на 7 дней, 1 месяц и 6 месяцев - включают мониторинг 3-х аккаунтов',
                '7daysPlan': {
                    'title': 'Тарифы на 7 дней, 1 месяц и 6 месяцев - включают мониторинг 3-х аккаунтов',
                    'period': '7 дней',
                    'price': '1490₽',
                    'fullDescription': 'Тариф 7 дней:<br /> Полный мониторинг активности 3 аккаунтов за {totalPrice}₽ сроком на 7 дней с последующим автопродлением подписки.',
                },
                '1monthPlan': {
                    'period': '1 месяц',
                    'fullDescription': 'Тариф 1 месяц:<br /> Полный мониторинг активности 3 аккаунтов за {totalPrice}₽ сроком на 1 месяц с последующим автопродлением подписки.',
                },
                '6monthsPlan': {
                    'period': '6 месяцев',
                    'price': '5940₽',
                    'fullDescription': 'Тариф 6 месяцев:<br /> Полный мониторинг активности 3 аккаунтов за {totalPrice}₽ сроком на 6 месяцев с последующим автопродлением подписки.',
                },
                'premiumPlan': {
                    'title': 'PREMIUM',
                    'description': 'Расширенные возможности:<br /> - Неограниченное количество целей<br /> - Персональный менеджер<br /> - Улучшенные алгоритмы отслеживания активности<br /> - Телеграм-уведомления',
                    'aboutTariffBtnLabel': 'Подробнее о тарифе',
                    'fullDescription': 'Тариф Premium.<br /> После оплаты у вас появится возможность добавлять неограниченное количество целей для слежки, общаться напрямую с персональным менеджеров из тех.поддержки, также для вас будет активированы новые улучшенные алгоритмы слежки за {totalPrice}₽ сроком на 30 дней',
                },
            },
            'freeAccessAlert': {
                'title': 'Часть данных скрыта',
                'expiredDescription1': 'Вы используете бесплатный доступ, поэтому часть данных скрыта.',
                'expiredDescription2': 'Чтобы получить доступ ко всем данным перейдите на любой из тарифов',
                'selectPlanBtnLabel': 'Выбрать тариф',
                'continueMonitoringBtnLabel': 'Продолжайте наблюдение',
                'continueMonitoringDescription': 'Чтобы продолжить наблюдение за вашей целью и видеть все скрытые данные, необходимо перейти на любой из тарифов',
            },
            'freeAccessDataHiddenAlert': {
                'title': 'Данные скрыты',
                'description': 'Чтобы получить доступ к скрытым данным необходимо подключить любой из тарифов',
                'selectPlanBtnLabel': 'Выбрать тариф',
            },
            'freeAccessUnlockDataAlert': {
                'title': 'Анализ активности',
                'lastRefreshDate': 'Дата обновления',
                'unlockDataBtnLabel': 'Разблокировать данные',
            },
            'payment': {
                "form": {
                    "backButton": "Назад",
                    "formTitle": "Оплата",
                    "cardNumberInputLabel": "Оплата с помощью карты",
                    "cardNumberInputPlaceholder": "Номер карты",
                    "expiryDateInputPlaceholder": "ММ / ГГ",
                    "cvcInputPlaceholder": "CVC",
                    "countrySelectLabel": "Страна",
                    "countrySelectPlaceholder": "Выбрать страну",
                    "recurringWTrialPolicyAcceptanceLabel": "Нажимая на кнопку \"Оплатить\", в подтверждаете согласие с <a class=\"link\" href=\"{userAgreementUrl}\" target=\"_blank\"><b>Правилами сервиса</b></a> и <a class=\"link\" href=\"{privacyPolicyUrl}\" target=\"_blank\"><b>Политикой конфиденциальности</b></a>. Использование сервиса подразумевает автоматическое продление подписки. После пробного периода стоимость подписки составит {currencySign}{subscriptionValue}/{subscriptionPeriod}. Вы можете отменить подписку в любой момент.",
                    "recurringPolicyAcceptanceLabel": "Нажимая на кнопку \"Оплатить\", в подтверждаете согласие с <a class=\"link\" href=\"{userAgreementUrl}\" target=\"_blank\"><b>Правилами сервиса</b></a> и <a class=\"link\" href=\"{privacyPolicyUrl}\" target=\"_blank\"><b>Политикой конфиденциальности</b></a>. Вы также соглашаетесь на автоматическое продление подписки посредством регулярных платежей. Стоимость подписки составит {currencySign}{subscriptionValue}/{subscriptionPeriod} дней. Вы можете отменить подписку в любой момент.",
                    "policyAcceptanceLabel": "Нажимая на кнопку \"Оплатить\", в подтверждаете согласие с <a class=\"link\" href=\"{userAgreementUrl}\" target=\"_blank\"><b>Правилами сервиса</b></a> и <a class=\"link\" href=\"{privacyPolicyUrl}\" target=\"_blank\"><b>Политикой конфиденциальности</b></a>. А также согласиться на автоматическое продление подписки на сервис",
                    "payButtonText": "ОПЛАТИТЬ {currencySign}{amount} {currencyCode}",
                    "footer": "<b>Цена в {currencyCode}</b>. При оплате в другой валюте итоговая сумма платежа зависит от курса и доп. сборов вашего банка.",
                    "errorOnCardConfirm": "Не удалось подтвердить карту",
                    "unknownError": "Не известная ошибка",
                },
                "success": {
                    "paymentSucceedMessageLine1": "Оплата прошла успешно.",
                    "paymentSucceedMessageLine2": "Сервис доступен для использования.",
                    "startUsingLabel": "Начать пользоваться",
                },
                "stripe": {
                    "cardNumberPlaceholder": "Номер карты",
                    "cardNumberIsEmpty": "Введите номер карты",
                    "cardExpiryIsEmpty": "Введите срок действия карты",
                    "cardCvcIsEmpty": "Введите CVC код",
                },
            }
        },
    });
    locale.set(_locale);
}
export {
    _,
    setupI18n
};